var uniqueProdNamesArray = [];

collectionGetVariations = function (filteredDataProducts) {
  var variantPrice = [];
  var variantCompareAtPrice = [];

  var prodsWithVariants = [];

  var newlyLoadedProdsWithVariants = [];

  var newlyLoadedProdsHtml;

  var pageProducts = $(".product");

  var filteredDuplicateProducts = [];

  var quickShopObj = {};

  var lowestPrice;
  var highestPrice;
  var highestCompareAtPrice;

  var allPrices = [];
  var allCompareAtPrices = [];

  var variantsPriceRanges = false;
  var variantsSamePrices = false;

  var htmlOutput = "";

  var percentOff;

  var htmlSaleLabel = '<p class="product-sale-tag">on sale</p>';

  var currentProductPrice = "";
  var currentProductCompareAtPrice = "";

  if (filteredDataProducts) {
    pageProducts = $(filteredDataProducts).filter(".product");
  }

  function checkArrValueSameness(array) {
    return !array.some(function (value, index, array) {
      return value !== array[0];
    });
  }

  function checkIfSale(mainProd) {
    lowestPrice = 0;
    highestPrice = 0;
    highestCompareAtPrice = 0;

    allPrices = [];
    allCompareAtPrices = [];

    variantsPriceRanges = false;
    variantsSamePrices = false;

    htmlOutput = "";

    percentOff = 0;
    currentProductPrice = $(mainProd)
      .eq(0)
      .find(".product-price")
      .data("price");
    currentProductCompareAtPrice = $(mainProd)
      .eq(0)
      .find(".product-price")
      .data("compare-at-price");

    allPrices.push(currentProductPrice);

    if (currentProductCompareAtPrice > 0) {
      allCompareAtPrices.push(currentProductCompareAtPrice);
    }

    $(mainProd)
      .eq(0)
      .find(".variant-price")
      .each(function () {
        if ($(this).data("variant-price") > 0) {
          allPrices.push($(this).data("variant-price"));
        }
      });

    $(mainProd)
      .eq(0)
      .find(".variant-compare-at-price")
      .each(function () {
        if ($(this).data("variant-compare-at-price") > 0) {
          allCompareAtPrices.push($(this).data("variant-compare-at-price"));
        }
      });

    // console.log(allCompareAtPrices);

    if (allPrices.length > 0) {
      lowestPrice = Math.min.apply(Math, allPrices);

      highestPrice = Math.max.apply(Math, allPrices);
    }

    if (allCompareAtPrices.length > 0) {
      highestCompareAtPrice = Math.max.apply(Math, allCompareAtPrices);
    }

    // 		if (highestCompareAtPrice > 0) {
    // 			var largestPrice;

    // 			var arePricesTheSame = checkArrValueSameness(allPrices);

    // 			if(arePricesTheSame === true) {
    // 				percentOff = Math.round((currentProductCompareAtPrice - currentProductPrice) * 100 / currentProductCompareAtPrice);

    // 				htmlOutput = "<p><s>"+slate.Currency.formatMoney(currentProductCompareAtPrice)+"</s></p><p>"+slate.Currency.formatMoney(currentProductPrice)+"<span class='price-sale-percent'>("+percentOff+"% OFF)</span></p>";

    // 				$(mainProd).eq(0).find(".product-price .product-price-wrapper").html(htmlOutput);

    // // 				if($(mainProd).eq(0).find('.product-sale-tag').length < 1){
    // // 					$(mainProd).eq(0).find(".colour-swatches").after(htmlSaleLabel);
    // // 				}
    // 			}
    // 			else {
    // 				percentOff = Math.round((highestCompareAtPrice - lowestPrice) * 100 / highestCompareAtPrice);

    // 				htmlOutput = "<p><s>"+slate.Currency.formatMoney(highestCompareAtPrice)+"</s></p><p>"+slate.Currency.formatMoney(lowestPrice)+"<span class='price-sale-percent'>(UP TO "+percentOff+"% OFF)</span></p>";

    // 				$(mainProd).eq(0).find(".product-price .product-price-wrapper").html(htmlOutput);

    // // 				if($(mainProd).eq(0).find('.product-sale-tag').length < 1){
    // // 					$(mainProd).eq(0).find(".colour-swatches").after(htmlSaleLabel);
    // // 				}
    // 			}
    // 		}
  }

  function getColourSwatch(p, currentMainProduct, currentMainProductName) {
    var hex = "";

    for (var tag = 0; tag < p.tags.length; tag++) {
      if (p.tags[tag].indexOf("#") > -1) {
        hex = p.tags[tag];
        break;
      }
    }
    if (hex != "") {
      $(currentMainProduct)
        .find(".colour-swatches")
        .append(
          "  <div class='colour-swatch'><div class='swatch swatch-" +
            p.handle +
            "' style='background-color: " +
            hex +
            "'>" +
            p.title.trim() +
            " </div></div>\n\r"
        );
    }
  }

  function getPrices(p, currentMainProduct, currentMainProductName) {
    $(currentMainProduct)
      .find(".variant-prices")
      .append(
        "<div class='variant-price' data-variant-price=" +
          p.price +
          "> </div> <div class='variant-compare-at-price' data-variant-compare-at-price=" +
          p.compare_at_price +
          "> </div>"
      );
  }

  function getFeturedImage(p, currentMainProduct) {
    if (p.featured_image != null) {
      $(currentMainProduct)
        .find(".product-images")
        .append(
          "<div class='product-image product-image-swatch image-" +
            p.handle +
            "'><a href='" +
            p.url +
            "' class='product-featured-image'><img src='" +
            slate.Image.getSizedImageUrl(p.featured_image, "480x480") +
            "' alt='" +
            p.featured_image.alt +
            "' /></a></div>\n\r"
        );
    }
  }

  function ajaxGetInfo(
    productColourHandlesArray,
    currentMainProduct,
    currentMainProductName,
    index
  ) {
    var colourHandleName = "";

    jQuery.getJSON(
      "/products/" + productColourHandlesArray + ".js",
      function (p) {
        if (p.available == true) {
          colourHandleName = productColourHandlesArray;

          getColourSwatch(p, currentMainProduct, currentMainProductName);

          getFeturedImage(p, currentMainProduct, currentMainProductName);

          getPrices(p, currentMainProduct, currentMainProductName);

          var indexCount = parseInt(index) + 1;

          quickShopObj[currentMainProductName]["colours"][indexCount] =
            colourHandleName;

          prodsWithVariants.push(currentMainProductName);
        }
      }
    );
  }

  function checkForDuplicates() {
    $(pageProducts).each(function () {
      var addProdName = $(this).data("prod-name");
      if (uniqueProdNamesArray.indexOf(addProdName) > -1) {
        $(this).remove();
      } else {
        uniqueProdNamesArray.push(addProdName);
        filteredDuplicateProducts.push(this);
      }
    });
  }

  var availableHandles = [];

  function getVariantInfo() {
    if (filteredDuplicateProducts.length > 0) {
      pageProducts = filteredDuplicateProducts;
    }

    $(pageProducts).each(function () {
      var currentMainProductName = $(this).data("prod-name");

      var productInfo = $(this).find(".quick-shop").data("product-info");
      var currentMainProduct = $(this);

      var productColourHandles = $(this)
        .find(".quick-shop")
        .attr("data-product-other-colour-handles");

      var currentMainProdPrice = $(this).find(".product-price").data("price");
      var currentMainProdCompareAtPrice = $(this)
        .find(".product-price")
        .data("compare-at-price");

      if (productColourHandles) {
        productColourHandlesArray = $.trim(productColourHandles).split(" ");
      } else {
        productColourHandlesArray = [];
      }

      variantHandles = [];

      availableHandles = [];

      quickShopObj[currentMainProductName] = {};
      quickShopObj[currentMainProductName].name = currentMainProductName;
      quickShopObj[currentMainProductName].colours = {};
      quickShopObj[currentMainProductName]["colours"][0] = productInfo;

      if (productColourHandlesArray.length > 1) {
        for (var i = 0; i < productColourHandlesArray.length; i++) {
          if (productInfo !== productColourHandlesArray[i]) {
            ajaxGetInfo(
              productColourHandlesArray[i],
              currentMainProduct,
              currentMainProductName,
              i
            );
          }
        }
      }
    });
  }

  function updateQuickShopDataAttr() {
    for (var colour in quickShopObj) {
      var handleStr = "";
      var prodName = quickShopObj[colour].name;

      var colHandlesArr = Object.values(quickShopObj[colour].colours);

      for (var j = 0; j < colHandlesArr.length; j++) {
        handleStr += colHandlesArr[j] + " ";
      }

      handleStr = $.trim(handleStr);

      $('[data-prod-name="' + prodName + '"]')
        .find(".quick-shop")
        .attr("data-product-other-colour-handles", handleStr);
    }
  }

  function update() {
    setTimeout(function () {
      for (var j = 0; j < prodsWithVariants.length; j++) {
        checkIfSale($('[data-prod-name="' + prodsWithVariants[j] + '"]'));
      }

      updateQuickShopDataAttr();

      $(".swatch").click(function () {
        var swatchName = $(this).attr("class").split(" ")[1];
        var colorName = swatchName.replace("swatch-", "");
        var currentSwatch = "." + $(this).attr("class").split(" ")[1];
        var findImage = ".image-" + colorName;
        $(this)
          .closest(".colour-swatches ")
          .find(".colour-swatch")
          .removeClass("selected");
        $(this).closest(".colour-swatch ").addClass("selected");
        $(this)
          .closest(".product")
          .find(".product-image-swatch")
          .css("z-index", "-1");

        $(this).closest(".product").find(findImage).css("z-index", "2");
      });
    }, 1000);
  }

  $(document).ajaxStop(function () {
    update();
  });

  update();

  checkForDuplicates();

  getVariantInfo();
};
